import Vue from 'vue';
import {api} from "../resources";

export default {
    namespaced: true,
    state: {
        tags_list: []
    },
    actions: {
        getTags({commit, rootState}) {
            const space_id = rootState.space.current_space.data.id;
            api.tags.get({space_id, 'per-page': 999}).then(res => {
                if (res.body.success) {
                    commit('setTags', res.body.data.rows);
                }
            })
        },

        createTag({}, data) {
            return api.tags.save(data);
        },
        updateTag({}, {id, ...data}) {
            return api.tags.update({id}, data);
        },
        deleteTag({}, id) {
            return api.tags.delete({id});
        }
    },
    mutations: {
        setTags(state, data) {
            state.tags_list = data;
        },
        pushTag(state, tag) {
            state.tags_list.push(tag);
        },
        replaceTagInList(state, updatedTag) {
            const tagIndex = state.tags_list.findIndex(tag => tag.id === updatedTag.id);
            Vue.set(state.tags_list, tagIndex, updatedTag);
        },
        removeTagFromList(state, id) {
            state.tags_list = state.tags_list.filter(tag => tag.id !== id)
        },
        clearTags(state) {
            state.tags_list = [];
        }
    }
}
